export default "__VITE_ASSET__C1LxxBD0__"